import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';

const styles = {
  linearSection: {
    paddingTop: 16,
    paddingBottom: 40,
    backgroundImage: `url(${Images.BottleLayer})`,
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
    backgroundSize: 'cover',
    zIndex: 0,
    '& .headline': {
      color: '#fff',
      fontWeight: '700',
      lineHeight: '160%',
    },
  },
  root: {
    marginTop: -40,
    paddingBottom: 80,
    '& .request-container': {
      zIndex: 1,
      position: 'relative',
    },
    '& .tracking-box': {
      background: '#fff',
      border: '1px solid #E9E9FF',
      borderRadius: 8,
      boxShadow: '0px 4px 12px rgba(7, 79, 147, 0.2)',
      padding: '22px 18px',
      cursor: 'pointer',
      '& .name': {
        color: Colors.black,
      },
      '& .info': {
        fontSize: 12,
      },
      '& .status': {
        background: '#ECF5F8',
        padding: '4px 12px',
        borderRadius: 12,
        color: Colors.black,
      },
    },
  },
};

export default styles;
